// src/utils/constants.js
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  OFFICERS: '/officers',
  SCAN_HISTORY: '/scan-history',
  REPORTS: '/reports',
  SETTINGS: '/settings'
};

export const OFFICER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const SCAN_TYPES = {
  QR_CODE: 'QR Code',
  BARCODE: 'Barcode'
};

export const NOTIFICATION_TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
};

export const FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view'
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100]
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh'
  },
  OFFICERS: {
    LIST: '/api/officers',
    CREATE: '/api/officers',
    UPDATE: '/api/officers/:id',
    DELETE: '/api/officers/:id',
    GET_BY_ID: '/api/officers/:id'
  },
  SCANS: {
    LIST: '/api/scans',
    EXPORT: '/api/scans/export'
  },
  REPORTS: {
    DASHBOARD_STATS: '/api/reports/dashboard',
    PERFORMANCE: '/api/reports/performance',
    EXPORT: '/api/reports/export'
  }
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Session expired. Please login again.',
  FORBIDDEN: 'You do not have permission to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.'
};

export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Successfully logged in',
  OFFICER_CREATED: 'Officer created successfully',
  OFFICER_UPDATED: 'Officer updated successfully',
  OFFICER_DELETED: 'Officer deleted successfully',
  SETTINGS_SAVED: 'Settings saved successfully'
};